import { render } from "./Error.vue?vue&type=template&id=40606fce"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Miftah Faridl\\Documents\\KIM-APPS\\motul-power-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__